import 'is-in-viewport';

$( function() {
	animateInViewport();

	lazyLoadImages();

	$( window ).on( 'scroll resize', function() {
		lazyLoadImages();
	} );
} );

$( window ).scroll( function() {
	setTimeout( function() {
		animateInViewport();
	}, 100 );
} );

export function animateInViewport() {
	$( '.lazyload, .move-up-in-viewport, .move-down-in-viewport, .move-left-in-viewport, .move-right-in-viewport, .fade-in-in-viewport, .zoom-in-in-viewport, .active-in-viewport, .full-width-in-viewport, .full-height-in-viewport' ).each( function() {
		var $this = $( this );

		if ( $this.is( ':in-viewport' ) ) {
			$this.addClass( 'active' );
		}
	} );
}

export function lazyLoadImages() {
	$( '.lazyload' ).each( function() {
		var $this = $( this );
		var rect = this.getBoundingClientRect();
		var windowHeight = window.innerHeight;

		if ( rect.top < windowHeight * 2 && rect.bottom > 0 ) {
			if ( !$this.hasClass( 'loaded' ) ) {
				$this.attr( 'src', $this.attr( 'data-src' ) ).addClass( 'loaded' );
			}
		}
	} );
}
